import { Grid as BaseGrid, Divider as BaseDivider, styled } from '@mui/material'
import { Dialog as BaseDialog } from '@chilecompra/react-kit/components'

export const Dialog = styled(BaseDialog)``
export const Divider = styled(BaseDivider)``
export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`
